import {
  CountAdminsRequest,
  CountAdminsResponse,
  DistrictAdminOnboardingCheckRequest
} from "../../../../types/gqlTypes/graphql"
import { executeQuerySideload } from "../../helpers/studyPlan"
import { apolloCubeClient } from "../../helpers/studyPlan/studyPlanApolloStatic"
import {
  CHECK_ONBOARDING_QUERY,
  GET_DISTRICT_ADMIN,
  GET_DISTRICT_ADMINS_COUNT_QUERY
} from "./orgDistrictAdminQueries"

export async function getDistrictAdmin(id: string) {
  const { data } = await apolloCubeClient.query({
    query: GET_DISTRICT_ADMIN,
    variables: { id },
    fetchPolicy: "network-only" // Always fetch fresh data
  })

  return data?.districtAdmin?.get || null
}

export async function districtAdminCheckOnboarding(
  data: DistrictAdminOnboardingCheckRequest
): Promise<boolean> {
  const response = await executeQuerySideload(CHECK_ONBOARDING_QUERY, { data })
  return response.districtAdmin.checkOnboarding.shouldShowOnboarding
}

export const getDistrictAdminsCount = async (
  data: CountAdminsRequest
): Promise<CountAdminsResponse> => {
  const response = await executeQuerySideload(GET_DISTRICT_ADMINS_COUNT_QUERY, {
    data
  })

  return response?.districtAdmin.count
}
